import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    width: 80,
    height: '100%',
    position: 'fixed',
    left: 0,
    top: 0,
    background: 'rgba(0,0,0,0.2)',
    padding: '55px 40px'
  },
  pointrLogo: {
    height: 55
  }
})
